import Adjust from '@adjustcom/adjust-web-sdk';

/**
 * Definición de la clase HeaderService, se usa para configurar el header en cada pantalla
 *
 * *HeaderService class definition, it's used to set up header in each screen*
 *
 * @type {class}
 */
export class AdjustEvent {

  adjustTrackEvent(event: any) {
    Adjust.trackEvent(event);
  }

}
